import axios from 'axios'
import { clone, objectSnakeToCamelCase, getDefaultStrDate } from '@/util/libUtil.js'
import defaultCoverageAvatelForm from '@/util/defaultCoverageAvatelForm'



const state = () => ({
	coverageAvatel: {
		form: clone(defaultCoverageAvatelForm),
		isOpenCoverageAvatel: false,
		isLoadingCoverageAvatel: false,
		coverageDataAvatel: null,
	},
	paths: {
		coverageAvatelPath: '/api/scraping/avatel/cliente/cobertura/',
		geoCodingAvatelPath: '/api/scraping/avatel/cliente/geocoding/',
	}
})

const mutations = {
	coverageAvatelForm(state, val) {
		state.coverageAvatel.form = clone(val)
	},
	coverageAvatelData(state, val) {
		state.coverageAvatel.coverageDataAvatel = val
	},
	isOpenCoverageAvatel: (state, val) => {
		state.coverageAvatel.isOpenCoverageAvatel = val
	},
	isLoadingCoverageAvatel: (state, val) => {
		state.coverageAvatel.isLoadingCoverageAvatel = val
	},
	resetCoverageAvatelData: (state) => {
		state.coverageAvatel.coverageDataAvatel = null;
	}
}

const actions = {
	async consultCoverageAvatel({ dispatch, getters, state, commit }, form) {
		try {
			const res = await axios.get(getters.getEndpointFromPath(state.paths.coverageAvatelPath), {
				params: form
			})
			commit('coverageAvatelData', res.data)
		} catch (error) {
			console.log(error)
		}
	},

	async consultGeoCodingAvatel({ dispatch, getters, state, commit }, form) {
		try {
			return await axios.get(getters.getEndpointFromPath(state.paths.geoCodingAvatelPath), {
				params: form
			})
		} catch (error) {
			console.log(error)
		}
	}
}

const getters = {
	getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
		rootState.general.host + endpoint
	)
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}